import React from 'react';

export const matchesParameterName = (item, query = '') => {
  const name = item.display_name || item.name || item.parameter_display_name || item.parameter_key || '';
  return name.toLowerCase().includes(query.trim().toLowerCase());
};

// Sort a filtered copy for display only; retain the order within each group.
export const parameterTableRows = (items, query) => items
  .filter(item => matchesParameterName(item, query))
  .sort((a, b) => Number(Boolean(a.system)) - Number(Boolean(b.system)));

export default function ConfigurationTableSearch({ value = '', onChange, label, className = 'mb-3 sm:max-w-sm' }) {
  return (
    <input
      type="search"
      aria-label={label}
      placeholder="Search by name..."
      value={value}
      onChange={event => onChange(event.target.value)}
      className={`w-full min-w-0 px-3 py-2 border border-gray-300 rounded-md text-sm global-input ${className}`}
    />
  );
}
